import React from "react";
import WorkCard from "./workcard";
import { useState, useEffect, useRef } from "react";

export default function OurWork({ content }) {

    const [isVisible, setIsVisible] = useState(false);
    const componentRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            if (componentRef.current) {
                const top = componentRef.current.getBoundingClientRect().top;
                const windowHeight = window.innerHeight;
                if (top < windowHeight) {
                    setIsVisible(true);
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Check on mount in case the component is already in the viewport

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    return (
        <div className={`container mx-auto  py-10 transition-opacity duration-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`} ref={componentRef}>
            <h2 className="lg:text-6xl md:text-3xl text-xl lg:px-[100px] md:px-[60px] px-[30px] font-bold text-white mt-10 mb-20">
                <span className="text-yellow-500">{content.title.split(" ")[0]}</span>{" "}
                {content.title.split(" ").slice(1).join(" ")}
            </h2>
            <div className="px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
                {content.data.map((project, index) => (
                    <WorkCard key={index} data={project} />
                ))}
            </div>
        </div>
    );
}